
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

interface PhotoPreviewProps {
  photoUrl: string;
}

const PhotoPreview: React.FC<PhotoPreviewProps> = ({ photoUrl }) => {
  if (!photoUrl) return null;

  return (
    <Card className="card-warm">
      <CardContent className="p-4">
        <div className="text-sm font-medium mb-2 text-sunset-dark">Current Photo</div>
        <div className="aspect-video bg-muted rounded overflow-hidden max-w-sm border border-border">
          <img 
            src={photoUrl} 
            alt="Terrace photo preview"
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }}
          />
          <div className="hidden w-full h-full flex items-center justify-center text-muted-foreground">
            <div className="text-center">
              <AlertCircle className="h-8 w-8 mx-auto mb-2" />
              <div>Invalid image URL</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PhotoPreview;
